/* eslint camelcase: 0 */
import { InvitationRequest } from '@/infrastructure/network/Monitaro/schema/models'
import { IInvitationProps } from '@/entities/Invitation'

export const toInvitationRequest = (props: IInvitationProps): InvitationRequest => {
  const { hospitalName, name, email } = props
  return {
    hospital_name: hospitalName,
    name,
    email
  }
}
